import Dialog from "../1. Core/Controls/Dialog/Dialog";
import {Card, CardStatus, Promocode, PromocodeType, VideoSource} from "./types";
import {ServerAPI} from "../1. Core/ServerAPI";
import TextField from "../1. Core/Controls/TextField/TextField";
import Select from "../1. Core/Controls/Select/Select";
import NumField from "../1. Core/Controls/TextField/NumField";
import SelectFighterCtrl from "../2. Athletes/SelectFighterCtrl";
import NP from "../1. Core/NP";
import IconSelect from "../1. Core/Controls/Select/IconSelect";
import {getCountries, getTournaments, ITournament} from "../10. Battle/Util";
import {IState} from "../2. Athletes/StatesList";
import {SportType} from "../10. Battle/types";
import DateInput from "../1. Core/Controls/DateInput/DateInput";
let moment = require('moment');

export default class EditPromocodeSourceDialog extends Dialog {


    private _Promocode: Promocode;
    private _code: TextField;
    private _type: Select;
    private _quantity: NumField;
    private _statusSelect: Select;
    private _athleteCombo: SelectFighterCtrl;
    private _cardSelect: Select;
    private _tournamentCombo: IconSelect;
    private _countryCombo: Select;
    private _startDateInput: DateInput;
    private _endDateInput: DateInput;


    constructor(props: any) {
        super(props);
    }

    _initFields(settings: object) {
        this._Promocode = {} as Promocode;
        super._initFields(settings);
        this._Mode = 'FullHeight';
        this._Caption = 'VideoSource';
        this._CloseOnFrameMouseDown = true;
        this._ShowHeader = true;
        this._ShowCloseButton = true;
        this._OkRK = 'Save'
        this._AutoDestroy = true;
    }

    _render() {
        super._render();

        this._code = new TextField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Code'
        });

        this._startDateInput = new DateInput({
            ParentNode: this._contentNode,
            FloatingLabel: "Start date",
            FontImage: NP.FontImages.event,
            EnabledEdit: false,
            Value: this._Promocode.startAt ? moment(this._Promocode.startAt).toDate() : null,
            EvChanged: () =>
            {
                this._Promocode.startAt = moment(this._startDateInput.getValue()).format('YYYY-MM-DD HH:mm:ss');
            }
        });

        this._endDateInput = new DateInput({
            ParentNode: this._contentNode,
            FloatingLabel: "End Date",
            FontImage: NP.FontImages.event,
            EnabledEdit: false,
            Value: this._Promocode.endAt ? moment(this._Promocode.endAt).toDate() : null,
            EvChanged: () =>
            {
                this._Promocode.endAt = moment(this._endDateInput.getValue()).format('YYYY-MM-DD HH:mm:ss');
            }
        });

        this._type = new Select({
            FloatingLabel: 'Type',
            ParentNode: this._contentNode,
            Value: 'subscription',
            Items: [
                {Content: 'Subscription', Value: PromocodeType.subscription},
                {Content: 'Coins', Value: PromocodeType.coins},
                {Content: 'Card', Value: PromocodeType.card},
            ],
            EvItemSelected: () => {
                let type = this._type.getSelectedItem()?.Value;

                NP.setIsVisible([this._quantity], type == PromocodeType.coins)

                if (type == PromocodeType.card) {
                    this._cardSelect.setIsVisible(true)
                    this._statusSelect.setIsVisible(true)
                } else {
                    this._cardSelect.setIsVisible(false)
                    this._statusSelect.setIsVisible(false)
                }
            }
        });



        this._quantity = new NumField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Quantity'
        });


        this._cardSelect = new Select({
            FloatingLabel: 'Card',
            ParentNode: this._contentNode,
            EvItemSelected: () => {
                let cardType = this._cardSelect.getSelectedItem()?.Content;

                NP.setIsVisible([this._athleteCombo, this._countryCombo, this._tournamentCombo], false)

                switch (cardType) {
                    case 'Athlete':
                        this._athleteCombo.setIsVisible(true)
                        break;
                    case 'Promotion':
                        this._tournamentCombo.setIsVisible(true)
                        break;
                    case 'Country':
                        this._countryCombo.setIsVisible(true)
                        break;
                }

            }
        });

        this._tournamentCombo = new IconSelect({
            ParentNode: this._contentNode,
            FloatingLabel: NP.RM.getString('Tournament'),
        });

        this._countryCombo = new Select({
            ParentNode: this._contentNode,
            FloatingLabel: NP.RM.getString('Country'),
            SelectedIndex: 0,
            Items: [{
                Value: null,
                FontImage: NP.FontImages.geo,
                Content: NP.RM.getString('All')
            }],
        });

        this._statusSelect = new Select({
            FloatingLabel: 'Status',
            ParentNode: this._contentNode,
            Items: [
                {Content: 'Gold', Value: CardStatus.gold},
                {Content: 'Silver', Value: CardStatus.silver},
                {Content: 'Bronze', Value: CardStatus.bronze}
            ]
        });

        this._athleteCombo = new SelectFighterCtrl({
            ParentNode: this._contentNode,
            FloatingLabel: NP.RM.getString('Athlete'),
            AllowCreateNew: false
        });


        NP.setIsVisible([this._athleteCombo, this._countryCombo,
            this._statusSelect,
            this._tournamentCombo, this._cardSelect], false)

        this.refresh()
    }


    async refresh() {
        this._code.setValue(this._Promocode.code)
        this._type.setValue(this._Promocode.type)
        this._quantity.setValue(this._Promocode.quantity)



        const states = await getCountries(true) as IState[];
        this._countryCombo.setItems(states.map(state => ({Value: state.Id, FontImage: NP.FontImages.geo, Content: state.Name})));

        const res = await getTournaments(SportType.MMA) as ITournament[]
        this._tournamentCombo.addItems(res.map(t => ({Value: t.Id, FontImage: NP.FontImages.event, Content: t.Name, Data: t})));

        let cards = await ServerAPI.get<Card[]>("/cards/items")


        this._cardSelect.setItems(cards.map(c => ({
            Content: c.name,
            Value: c.id
        })))

        if (this._Promocode.type == PromocodeType.card) {
            this._statusSelect.setValue(this._Promocode.statusCard)
            this._cardSelect.setValue(this._Promocode.cardId)
            switch (this._cardSelect.getSelectedItem()?.Content) {
                case 'Athlete':
                    this._athleteCombo.setValue(this._Promocode.exCardData)
                    break;
                case 'Promotion':
                    this._tournamentCombo.setValue(this._Promocode.exCardData)
                    break;
                case 'Country':
                    this._countryCombo.setValue(this._Promocode.exCardData)
                    break;
            }
        }
    }


    async _onOkButtonClick() {

        this._Promocode.code = this._code.getValue()
        this._Promocode.type = this._type.getValue()
        this._Promocode.quantity = this._quantity.getValue()

        if (this._Promocode.type == PromocodeType.card) {

            this._Promocode.statusCard = this._statusSelect.getValue()
            this._Promocode.cardId = this._cardSelect.getValue()

            let data = null;
            switch (this._cardSelect.getSelectedItem()?.Content) {
                case 'Athlete':
                    data = this._athleteCombo.getValue()
                    if (!data)
                        return
                    break;
                case 'Promotion':
                    data = this._tournamentCombo.getValue()
                    if (!data)
                        return
                    break;
                case 'Country':
                    data = this._countryCombo.getValue()
                    if (!data)
                        return
                    break;
            }
            this._Promocode.exCardData = data;
        }
        else
        {
            this._Promocode.cardId = null
            this._Promocode.exCardData = null
            this._Promocode.statusCard = null
        }



        if (this._Promocode.id)
            await ServerAPI.put(`/promocode/${this._Promocode.id}`, this._Promocode)
        else
            await ServerAPI.post(`/promocode/`, this._Promocode);


        this.EvOkButtonClick.fire(this);
        this.hide();
    }
}
